import Icon from '../components/Icon.vue'

Icon.register({
  'caret-left': {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M192 127.3v257.3c0 17.8-21.5 26.7-34.1 14.1l-128.7-128.7c-7.8-7.8-7.8-20.5 0-28.3l128.7-128.7c12.6-12.6 34.1-3.7 34.1 14.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-left.js
// module id = 1151
// module chunks = 0